(() => {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(() => {
    const header = document.querySelector('.section-header');
    if (!header || header.dataset.stickyForceInit === '1') return;
    header.dataset.stickyForceInit = '1';

    const sentinel = document.createElement('div');
    sentinel.setAttribute('data-sticky-force-sentinel', 'true');
    sentinel.style.cssText = 'height:1px;margin-top:-1px;pointer-events:none;';
    header.parentNode.insertBefore(sentinel, header);

    const spacer = document.createElement('div');
    spacer.setAttribute('data-sticky-force-spacer', 'true');
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    const orig = {
      position: header.style.position,
      top: header.style.top,
      left: header.style.left,
      right: header.style.right,
      width: header.style.width,
      zIndex: header.style.zIndex,
      transform: header.style.transform
    };

    const getTopOffset = () => {
      const t = parseFloat(getComputedStyle(header).top);
      return Number.isFinite(t) ? t : 0;
    };

    let isFixed = false;

    function setImportant(el, prop, value) {
      el.style.setProperty(prop, value, 'important');
    }

    function enableFixed() {
      if (isFixed) return;
      isFixed = true;

      spacer.style.height = `${header.getBoundingClientRect().height}px`;
      spacer.style.display = '';

      const top = `${getTopOffset()}px`;

      setImportant(header, 'position', 'fixed');
      setImportant(header, 'top', top);
      setImportant(header, 'left', '0');
      setImportant(header, 'right', '0');
      setImportant(header, 'width', '100%');
      setImportant(header, 'z-index', '4000');
      setImportant(header, 'transform', 'translateZ(0)');

      header.classList.add('sticky-force--fixed');
    }

    function disableFixed() {
      if (!isFixed) return;
      isFixed = false;

      spacer.style.display = 'none';

      header.classList.remove('sticky-force--fixed');

      header.style.removeProperty('position');
      header.style.removeProperty('top');
      header.style.removeProperty('left');
      header.style.removeProperty('right');
      header.style.removeProperty('width');
      header.style.removeProperty('z-index');
      header.style.removeProperty('transform');

      if (orig.position) header.style.position = orig.position;
      if (orig.top) header.style.top = orig.top;
      if (orig.left) header.style.left = orig.left;
      if (orig.right) header.style.right = orig.right;
      if (orig.width) header.style.width = orig.width;
      if (orig.zIndex) header.style.zIndex = orig.zIndex;
      if (orig.transform) header.style.transform = orig.transform;
    }

    const mo = new MutationObserver(() => {
      if (!isFixed) return;
      if (getComputedStyle(header).position !== 'fixed') enableFixed();
    });
    mo.observe(header, { attributes: true, attributeFilter: ['style', 'class'] });

    const io = new IntersectionObserver((entries) => {
      const e = entries[0];
      if (!e || e.isIntersecting) disableFixed();
      else enableFixed();
    }, { threshold: [1] });

    io.observe(sentinel);

    window.addEventListener('resize', () => {
      if (isFixed) spacer.style.height = `${header.getBoundingClientRect().height}px`;
    }, { passive: true });
  });
})();



(() => {
  if (window.__headerSearchFixInit) return;
  window.__headerSearchFixInit = true;

  const openSearch = (evt) => {
    evt.preventDefault();
    document.body.classList.add('show-search');
    const header = document.querySelector('page-header');
    if (header) {
      header.style.minHeight = '168px';
    }
    const input = document.querySelector('.main-search__input');
    if (input) {
      setTimeout(() => input.focus(), 50);
    }
  };

  const closeSearch = (evt) => {
    if (!document.body.classList.contains('show-search')) return;
    evt.preventDefault();
    document.body.classList.remove('show-search');
    const header = document.querySelector('page-header');
    if (header) {
      header.style.minHeight = '';
    }
  };

  document.addEventListener('click', (evt) => {
    const opener = evt.target.closest('.show-search-link');
    if (opener) {
      openSearch(evt);
      return;
    }

    const closer = evt.target.closest('.main-search__close, .page-shade, .header-shade');
    if (closer) {
      closeSearch(evt);
    }
  });
})();
